import { SHOW_SUCCESS_BAR, RESET_SNACK_BAR, SHOW_DANGER_BAR } from '../actions/types';
import { updateObject } from '../utility';

const initialState = {
    snackBarOptions: {
        showSnackbar: false,
        message: '',
        variant: ''
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SUCCESS_BAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: true,
                    message: action.payload,
                    variant: 'success'
                }
            });
        case SHOW_DANGER_BAR:
            return updateObject(state, {
                snackBarOptions: {
                    showSnackbar: true,
                    message: action.payload,
                    variant: 'error'
                }
            });
        case RESET_SNACK_BAR:
            return updateObject(state, {
                snackBarOptions: { showSnackbar: action.payload }
            });
        default:
            return state;
    }
};
